<template>
    <div v-if="mostrar" class="modal-overlay">
      <div class="modal-container">
        <!-- Cabeçalho -->
        <div class="modal-header">
          <h6>Supervisão</h6>
          <i class="bi bi-x-circle close-icon" @click="fechar"></i>
        </div>
  
        <!-- Conteúdo -->
        <div class="modal-content">
          <ul class="list-unstyled mb-3">
              <li><strong>Solicitada por:</strong> {{ supervisao.instrutor }}</li>
              <li><strong>Turma:</strong> {{ supervisao.turma }}</li>
          </ul>
          <p><strong>Realizada por:</strong> {{ supervisao.por === null ? userName : supervisao.por }}</p>
  
          <!-- Campo Aluno -->
          <div class="row mb-2">
            <div class="col">
              <label>Aluno</label>
              <input
                type="text"
                :value="supervisao.aluno"
                class="form-control"
                disabled
              />
            </div>
          </div>
  
          <!-- Campo Observações -->
          <div class="form-group mb-2">
            <label for="obs">Observações <span class="required">*</span></label>
            <textarea
              id="obs"
              v-model="form.observacoes"
              class="form-control"
              rows="6"
              :style="{ height: modoVisualizacao ? '200px' : '100px' }"
              :disabled="modoVisualizacao"
              required
            ></textarea>
          </div>
        </div>
  
        <!-- Botões -->
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="fechar">
            {{ modoVisualizacao ? 'Fechar' : 'Cancelar' }}
          </button>
  
          <template v-if="!modoVisualizacao">
            <button
              class="btn btn-primary"
              :disabled="!form.observacoes || isSubmitting"
              @click="salvar"
            >
              {{ isSubmitting ? 'Salvando…' : 'Salvar' }}
            </button>
            <button
              class="btn btn-success btn-finalizar"
              :disabled="!form.observacoes || isSubmitting"
              @click="finalizar"
            >
              {{ isSubmitting ? 'Processando…' : 'Finalizar' }}
            </button>
          </template>
        </div>
      </div>
    </div>
  </template>
    
  <script setup>
  import { ref, watch, computed, getCurrentInstance } from 'vue';
  import axios from '@/services/axios';
  import globalUtils from '@/utils/globalUtils';

  const instance = getCurrentInstance();
  const gs = instance.appContext.config.globalProperties.$globalState;
  const userName = gs.userName;

  const props = defineProps({
    mostrar: { type: Boolean, default: false },
    supervisao: { type: Object, required: true },
    modoVisualizacao: { type: Boolean, default: false }

  });
  const emit = defineEmits(['close','salvou']);
  
  const form = ref({
    observacoes: ''
  });
  const isSubmitting = ref(false);
  
  watch(
    () => props.mostrar,
    async visible => {

    if (!visible) return;

    form.value.observacoes = '';

    if (props.supervisao.realizada) {
        try {
        const res = await axios.get(
            `/operacional/supervisoes/${props.supervisao.id}`
        );
        form.value.observacoes = res.data.data.observacoes || '';
        } catch (err) {
        console.error('❌ Erro ao carregar observações:', err);
        }
    }
        },
    { immediate: true }
  );
  
  function fechar() {
    emit('close');
  }
  
  // Data de hoje formatada
  const hojeFormatado = computed(() => {
    return globalUtils.formatarData(new Date().toISOString());
  });

  async function salvar() {
    if (isSubmitting.value) return;
    isSubmitting.value = true;
    try {
      await axios.patch(
        `/operacional/supervisoes/${props.supervisao.id}`,
        { 
          observacoes: form.value.observacoes,
          realizada: true,
          por: userName,
          data_realizacao: hojeFormatado.value.split('/').reverse().join('-'),
        }
      );
      emit('salvou');
      fechar();
    } catch (err) {
      console.error('Erro ao salvar supervisão:', err);
    } finally {
      isSubmitting.value = false;
    }
  }
  
  async function finalizar() {
    if (isSubmitting.value) return;
    isSubmitting.value = true;
    try {
      await axios.patch(
        `/operacional/supervisoes/${props.supervisao.id}`,
        {
          observacoes: form.value.observacoes,
          finalizada: true,
          por: userName
        }
      );
      emit('salvou');
      fechar();
    } catch (err) {
      console.error('Erro ao finalizar supervisão:', err);
    } finally {
      isSubmitting.value = false;
    }
  }
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
  }
  .modal-container {
    background: #fff;
    width: 100%;
    max-width: 500px;
  }
  .modal-header {
    background: #ccc;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .close-icon {
    font-size: 1.5rem;
    cursor: pointer;
  }
  .modal-content {
    padding: 15px;
  }
  .modal-footer {
    padding: 10px 15px;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
  .required {
    color: red;
  }
  .btn {
  min-width: 70px;
  padding: 6px 15px;
  font-size: 14px;
  cursor: pointer;
  border: none;
}



  </style>
  